/*
This file fires the li_mobile_track events for the right rail recommendations

We generate a tracking id for each recommendation.
On page load, impression event containing Lynda recs, BM recs backfilled with more from author/featured slideshows are fired

The avro schemas used are deployed in http://viewvc.corp.linkedin.com/netrepo?view=revision&revision=1440433
*/
import TrackingUtils from './tracking-utils';

(function(utils, toArray) {

      // A constant for accessing the tracking id within a data attribute.
      var TRACKING_ID = 'tracking-id',

      // The default selector for identifying recommendation items.
      DEFAULT_SELECTOR = '.j-recommendation-tracking',

      // Event names used by the recommendations tracker.
      EVENTS = {
        impression: 'SlideShareRecommendationImpressionEvent',
        action: 'SlideShareRecommendationActionEvent'
      },

      // A TrackingUtils instance.
      trackingUtils = new TrackingUtils(),
      appId = trackingUtils.getAppId('recommendations'),

      // An object to be merged with all tracking data.
      baseTrackingData = {
        requestHeader: {
          pageKey: trackingUtils.getPageKey()
        }
      };

  /**
   * Takes an arbitrary number of data objects, appends a base tracking data
   * object to the collection, and then smashes all the objects into one for
   * delivery to a tracking endpoint.
   * @param {...Object} Any number of objects to merge into one.
   * @returns {Object}
   */
  function generateTrackingData() {
    var data = toArray(arguments);
    data.push(baseTrackingData);
    return $.extend.apply(null, data);
  }

  /**
   * Generates a collection of recommendations data to send to the tracking server.
   * @param {jQuery} $els A jQuery collection of recommendation items.
   * @todo Clean up the HTML (and the rest of the ga tracking stuff) to make use of a single recId
   * @returns {Object} The generated recommendations data.
   */
  function generateRecommendationsData($els) {

    return toArray($els).map(function(el) {

      var $el = $(el),
        recId = getRecommendationId($el),
        trackingId = $el.data(TRACKING_ID) || trackingUtils.generateTrackingID(16),
        recommendationData = {
          entityUrn: trackingUtils.getUrn($el.data('urn-type'), recId),
          sourceName: $el.data('source-name'),
          entityInstance: trackingId
        };

      // If the element doesn't have a tracking id for some reason, assign it to the one we generated above.
      if (!$el.data(TRACKING_ID)) {
        $el.data(TRACKING_ID, trackingId);
      }

      if ($el.attr('data-source-model')) {
        recommendationData.sourceModel = $el.attr('data-source-model');
      }

      return recommendationData;
    });
  }

  /**
   * Retrieves the recommendation's id depending on whether or not it's a Lynda item.
   * @param $el The item element to retrieve the data from.
   * @returns {String} The retrieved id.
   */
  function getRecommendationId($el) {
    return $el.attr('data-lynda-id') ? $el.data('lynda-id') : $el.data('ssid');
  }

  /**
   * Records an action event based on the clicked recommendation item.
   * @this {DOMElement} The clicked element (set by jQuery).
   */
  function fireAction() {

    var $el = $(this),
        recId = getRecommendationId($el),
        data = generateTrackingData({
          entityInstance: $el.data(TRACKING_ID),
          entityUrn: trackingUtils.getUrn($el.data('urn-type'), recId),
          actionType: 'VIEW_ENTITY'
        });

    trackingUtils.recordTrackingEvent(appId, EVENTS.action, data);
  }

  /**
   * Records an impression event that includes data from a passed config
   * as well as data from each recommendation item on the page.
   * @param {jQuery} $els A jQuery collection of recommendation items.
   * @param {Object} config Extra tracking data to include.
   * @param {String} config.designKey
   * @param {String} config.finalRankerModel
   * @param {String} config.slideshowId
   */
  function fireImpression($els, config) {

    var data = generateTrackingData({
      recommendations: generateRecommendationsData($els),
      recommendationsSetInstance: trackingUtils.generateTrackingID(16)
    }, {
      designKey: config.designKey,
      finalRankerModel: config.finalRankerModel,
      sourceUrn: trackingUtils.getUrn('Slideshow', config.slideshowId)
    });

    trackingUtils.recordTrackingEvent(appId, EVENTS.impression, data);
  }

  /**
   * An object that fires a impression and action events related to recommendations.
   * @param {Object} config The tracker's configuration object.
   * @param {String} config.selector Identifies the recommendation items.
   * @param {String} config.designKey The impression design key.
   * @param {String} config.finalRankerModel The impression finalRankerModel.
   * @param {String} config.slideshowId Which slideshow rendered these recommendations.
   * @constructor
   */
  function RecommendationsTracker(config) {
    this._$els = $(config.selector || DEFAULT_SELECTOR);
    this._$els.on('click', fireAction);
    fireImpression(this._$els, config);
  }

  utils.exports('tracking.Recommendations', RecommendationsTracker);

}(
  window.slideshare_object.utils,
  window.ssClientUtils.lang.toArray
));
